import { useNgSession } from "@/shared/ng/ng-session";

export async function logLogin() {
    const { isLoggedIn, session } = useNgSession();
    if (!isLoggedIn.value) return;

    fetch("/api/player/login", {
        method: "POST",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify({
            playerId: session.value.PlayerID,
            contact: {
                birthday: session.value.Birthday,
                city: session.value.City,
                firstName: session.value.PlayerName,
                lastName: session.value.PlayerLastName,
                email: session.value.PlayerEmail,
                phoneNumber: session.value.PlayerCellphone,
                vipLevel: session.value.PlayerVipLevel,
                registrationDate: session.value.PlayerRegistrationDate,
                countryCode: session.value.CountryCode,
            },
        }),
    });
}
